import React from 'react';
import { ImagePicker } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import util from '@utils/util';
import { convertStyleData } from '@utils/tools';

import { ImgUpload } from 'src/common/img-upload/ImgUpload';
import { RequestStatus } from 'src/common/request-status/RequestStatus';

import './BbsCustomComponent.less';

/**
 * type: 'bbs'
 * 组件：评论组件
 */
export default class BbsCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    const compindex = props.index;
    const pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    let bbsData = pageInstance.data.eles[compindex],
        bbs_idx_value = '';
    let pageRequestNum = pageInstance.requestNum;

    if(bbsData.customFeature.ifBindPage && bbsData.customFeature.ifBindPage !== 'false'){
      if(pageInstance.page_form && pageInstance.page_form != 'none'){
        bbs_idx_value = pageInstance.page_form + '_' + pageInstance.dataId;
      }else{
        bbs_idx_value = pageInstance.page_router;
      }
    }else{
      bbs_idx_value = app.getAppId();
    }
    let newdata = {};
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].content.data'] = [];
    newdata['eles[' + compindex + '].content.is_more'] = 1;
    newdata['eles[' + compindex + '].content.current_page'] = 0;
    pageInstance.setData(newdata);

    pageInstance.requestNum = pageRequestNum + 1;
    app.sendRequest({
      hideLoading: true,   // 页面第一个请求才展示loading
      url: '/index.php?r=AppData/getFormDataList',
      method: 'post',
      data: {
        form: 'bbs',
        is_count: bbsData.customFeature.ifLike ? 1 : 0,
        page: 1,
        idx_arr: {
          idx: 'rel_obj',
          idx_value: bbs_idx_value
        }
      },
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function(res){
        let data = {};

        for(let i in res.data){
          res.data[i].form_data.content.addTime = res.data[i].form_data.content.addTime.slice(2, 19);
        }
        if (res.count > 99){
          res.count = '99+'
        } else if (res.count > 999) {
          res.count = '999+'
        } else if (res.count > 10000) {
          res.count = '1w+'
        }

        data['eles[' + compindex + '].content'] = res;
        data['eles[' + compindex + '].comment'] = {};
        data['eles[' + compindex + '].loading'] = false;
        data['eles[' + compindex + '].loadingFail'] = false;
        pageInstance.setData(data);
      },
      fail: function (res) {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  }

  clickBbsReplyBtn = (event) => {
    event.stopPropagation();
    let dataset      = event.currentTarget.dataset;
    let pageInstance = app.getAppCurrentPage();
    let compindex       = dataset.compindex;
    let index        = dataset.index;
    let data         = {};
    data['eles[' + compindex + '].replyIndex'] = index;
    data['eles[' + compindex + '].bbsFocus'] = true;
    data['eles[' + compindex + '].isShowReplyDialog'] = true;
    pageInstance.setData(data);
  }

  bbsScrollFuc = (compindex) => {
    let pageInstance  = app.getAppCurrentPage();
    let bbsData       = pageInstance.data.eles[compindex];
    let bbs_idx_value = '';

    if (bbsData.loading || bbsData.content.is_more == 0) {
      return ;
    }
    let newdata = {};
    newdata['eles[' + compindex + '].loading'] = true;
    pageInstance.setData(newdata);

    if (bbsData.customFeature.ifBindPage && bbsData.customFeature.ifBindPage !== 'false') {
      if (pageInstance.page_form && pageInstance.page_form != 'none') {
        bbs_idx_value = pageInstance.page_form + '_' + pageInstance.dataId;
      } else {
        bbs_idx_value = pageInstance.page_router;
      }
    } else {
      bbs_idx_value = app.getAppId();
    }
    app.sendRequest({
      url: '/index.php?r=AppData/getFormDataList',
      method: 'post',
      data: {
        form: 'bbs',
        is_count: bbsData.customFeature.ifLike ? 1 : 0,
        page: bbsData.content.current_page + 1,
        idx_arr: {
          idx: 'rel_obj',
          idx_value: bbs_idx_value
        }
      },
      hideLoading: true,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        let data = {},
            newData = {};
        data = res;

        data.data = bbsData.content.data.concat(res.data);
        data.isloading = false;

        newData['eles[' + compindex + '].content'] = data;
        newData['eles[' + compindex + '].loading'] = false;
        newData['eles[' + compindex + '].loadingFail'] = false;
        pageInstance.setData(newData);
      },
      fail: function (res) {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  }

  showBbsReplyDialog = (e) => {
    this.input.focus();
    let compindex = e.currentTarget.dataset.compindex,
        pageInstance = app.getAppCurrentPage(),
        newdata = {};
    newdata['eles[' + compindex + '].isShowReplyDialog'] = true;
    newdata['eles[' + compindex + '].bbsFocus'] = true;
    if (pageInstance.data.eles.page_hasNavBar){
      newdata['eles[' + compindex + '].dialogTop'] = app.globalData.topNavBarHeight || 0;
    }
    pageInstance.setData(newdata);
  }

  hideBbsReplyDialog = (e) => {
    let compindex = e.currentTarget.dataset.compindex,
      pageInstance = app.getAppCurrentPage(),
      newdata = {};
    newdata['eles[' + compindex + '].isShowReplyDialog'] = false;
    newdata['eles[' + compindex + '].bbsFocus'] = false;
    newdata['eles[' + compindex + '].replyIndex'] = 'undefined';
    pageInstance.setData(newdata);
  }

  bbsInputComment = (event) => {
    let dataset      = event.target.dataset;
    let comment      = event.target.value;
    let pageInstance = app.getAppCurrentPage();
    let compindex       = dataset.compindex;
    let data         = {};
    data['eles[' + compindex + '].comment.text'] = comment;
    pageInstance.setData(data);
  }

  deleteCommentImage = (event) => {
    event.stopPropagation();
    let dataset      = event.currentTarget.dataset;
    let pageInstance = app.getAppCurrentPage();
    let compindex       = dataset.compindex;
    let index        = dataset.index;
    let oldData = pageInstance.data.eles[compindex].comment.img
    let data         = {};
    oldData.splice(index, 1)
    data['eles[' + compindex + '].comment.img'] = oldData;
    pageInstance.setData(data);
  }

  uploadBbsCommentImage = (res) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex    = this.props.index;
    let data         = {};

    let oldData = pageInstance.data.eles[compindex].comment.img || [];
    data['eles[' + compindex + '].comment.img'] = [...oldData, res];
    pageInstance.setData(data);
  }

  bbsPublishComment = (event) => {
    let dataset      = event.currentTarget.dataset;
    let pageInstance = app.getAppCurrentPage();
    let compindex       = dataset.compindex;
    let bbsData      = pageInstance.data.eles[compindex];
    let comment      = bbsData.comment;
    let param;

    if (!comment.text || !comment.text.trim()) {
      app.showModal({
        content: '请输入评论内容'
      })
      return;
    }

    comment.text = encodeURIComponent(comment.text);

    delete comment.showReply;
    comment.addTime = util.formatTime();

    param = {};
    param.nickname = app.globalData.userInfo.nickname;
    param.cover_thumb = app.globalData.userInfo.cover_thumb;
    param.user_token = app.globalData.userInfo.user_token;
    param.page_url = pageInstance.page_router;
    param.content = comment;
    param.rel_obj = '';
    if (bbsData.customFeature.ifBindPage && bbsData.customFeature.ifBindPage !== 'false') {
      if (pageInstance.page_form && pageInstance.page_form != 'none') {
        param.rel_obj = pageInstance.page_form + '_' + pageInstance.dataId;
      } else {
        param.rel_obj = pageInstance.page_router;
      }
    } else {
      param.rel_obj = app.getAppId();
    }

    app.sendRequest({
      url: '/index.php?r=AppData/addData',
      method: 'post',
      data: {
        form: 'bbs',
        form_data: param
      },
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        let commentList = bbsData.content.data || [],
            newdata = {};

        param.id = res.data;
        param.content.text = decodeURIComponent(param.content.text)
        newdata['eles[' + compindex + '].content.data'] = [{
          form_data: param,
          count_num: 0
        }].concat(commentList);
        let count = '';
        if (+bbsData.content.count + 1 <= 99){
          count = +bbsData.content.count + 1
        }else if (+bbsData.content.count + 1 > 99) {
          count = '99+'
        } else if (+bbsData.content.count + 1 > 999) {
          count = '999+'
        } else if (+bbsData.content.count + 1 > 10000) {
          count = '1w+'
        }
        newdata['eles[' + compindex + '].content.count'] = count;
        newdata['eles[' + compindex + '].comment'] = {};
        newdata['eles[' + compindex + '].isShowReplyDialog'] = false;
        newdata['eles[' + compindex + '].bbsFocus'] = false;
        newdata['eles[' + compindex + '].replyIndex'] = 'undefined';
        pageInstance.setData(newdata);
      }
    })
  }

  bbsPublishReply = (event) => {
    let dataset      = event.currentTarget.dataset;
    let pageInstance = app.getAppCurrentPage();
    let compindex       = dataset.compindex;
    let bbsData      = pageInstance.data.eles[compindex];
    let index        = bbsData.replyIndex;
    let form_data    = bbsData.content.data[index].form_data;
    let comment      = bbsData.comment;
    let param;
    if (!comment.text || !comment.text.trim()) {
      app.showModal({
        content: '请输入回复内容'
      })
      return;
    }

    comment.text = encodeURIComponent(comment.text);

    comment.addTime = util.formatTime();
    comment.reply = {
      nickname: form_data.nickname,
      text: form_data.content.text,
      img: form_data.content.img,
      user_token: form_data.user_token,
      reply: form_data.content.reply
    };

    param = {};
    param.nickname = app.globalData.userInfo.nickname;
    param.cover_thumb = app.globalData.userInfo.cover_thumb;
    param.user_token = app.globalData.userInfo.user_token;
    param.page_url = pageInstance.page_router;
    param.content = comment;
    param.rel_obj = '';
    if (bbsData.customFeature.ifBindPage && bbsData.customFeature.ifBindPage !== 'false') {
      if (pageInstance.page_form && pageInstance.page_form != 'none') {
        param.rel_obj = pageInstance.page_form + '_' + pageInstance.dataId;
      } else {
        param.rel_obj = pageInstance.page_router;
      }
    } else {
      param.rel_obj = app.getAppId();
    }

    app.sendRequest({
      url: '/index.php?r=AppData/addData',
      method: 'post',
      data: {
        form: 'bbs',
        form_data: param,
      },
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function(res){
        let commentList = bbsData.content.data || [],
            newdata = {};

        param.id = res.data;
        param.content.text = decodeURIComponent(param.content.text)
        if(commentList.length){
          delete commentList[index].replyText;
          delete commentList[index].showReply;
        }
        newdata['eles[' + compindex + '].content.data'] = [{
          form_data: param,
          count_num: 0
        }].concat(commentList);
        let count = '';
        if (+bbsData.content.count+1<=99){
          count = +bbsData.content.count + 1;
        }else if (+bbsData.content.count + 1 > 99) {
          count = '99+'
        } else if (+bbsData.content.count + 1 > 999) {
          count = '999+'
        } else if (+bbsData.content.count + 1 > 10000) {
          count = '1w+'
        }
        newdata['eles[' + compindex + '].content.count'] = count;
        newdata['eles[' + compindex + '].comment'] = {};
        newdata['eles[' + compindex + '].isShowReplyDialog'] = false;
        newdata['eles[' + compindex + '].bbsFocus'] = false;
        newdata['eles[' + compindex + '].replyIndex'] = 'undefined';
        pageInstance.setData(newdata);
      }
    })
  }

  previewImage = (e, options) => {
    e.stopPropagation();
    app.previewImage(options)
  }

  changeCount = (e) => {
    e.stopPropagation();
    app.changeCount(e);
  }

  stopPropagation = (e) => {
    e.stopPropagation();
  }

  render() {
    // 组件数据
    const pageInstance = app.getAppCurrentPage();
    const data = this.props.data;
    let {
      customFeature, style, content, isShowReplyDialog,
      dialogTop, comment, replyIndex
    } = this.props.data;

    comment = comment || {};

    const { mode, themeColor, ifLike } = customFeature;
    const styleObj = convertStyleData(style);

    return <div className={`custom-component element bbs ${mode === 1 ? 'bbs-mode1' : ''}`}
      style={styleObj}
      onAnimationEnd={(e) => this.animationEnd(e)}>
      {mode !== 1 &&
        <div className="comment-amount-p">
          <span className="ca-span">
            <span style={{ backgroundColor: themeColor }}></span>
            全部评论
          </span>
          {content.count || 0}
        </div>
      }
      {mode === 1 &&
        <div className="comment-amount-p">
          <span className="ca-span">
            <span style={{ backgroundColor: themeColor }}></span>
            全部评论
          </span>
          {content.count || 0}
        </div>
      }
      <div className="comment-container js-list-container">
        {content.data && content.data.map((item, index) => {
          return <div className="comment" key={index}>
            <img className="cover-img" src={item.form_data.cover_thumb || '//img.zhichiwangluo.com/zc_app_default_photo.png'} />
            <div className="comment-content">
              <div className="nickname-wrap">
                <label className="nickname">{item.form_data.nickname}</label>
                <label>
                  {item.form_data.content.reply && <span className="comment-reference-text">@{item.form_data.content.reply.nickname}</span>}
                  {item.form_data.content.text}
                </label>
              </div>
              {Array.isArray(item.form_data.content.img || '')
                ? <React.Fragment>
                  {item.form_data.content.img.map((el, index) => {
                    return <img className="comment-img"
                                key={index}
                                src={el}
                                data-src={el}
                                onClick={(e) => this.previewImage(e, {current: el, urls: item.form_data.content.img})} />
                  })}
                </React.Fragment>
                : <React.Fragment>
                  {item.form_data.content.img &&
                    <img className="comment-img"
                         src={item.form_data.content.img}
                         data-src={el}
                         onClick={(e) => this.previewImage(e, {current: el, urls: item.form_data.content.img})} />
                  }
                </React.Fragment>
              }
              <div>
                <label className="add-time">{item.form_data.content.addTime}</label>
                {ifLike &&
                  <label
                    className={`bbs-content-btn ico-moon ${item.has_count == 1 ? 'icon-collect-solid' : 'icon-collect'}`}
                    style={{ color: item.has_count == 1 ? '#f00' : '' }}
                    data-objrel={`bbs_${ item.form_data.id }`}
                    data-counted={item.has_count}
                    data-compindex={this.props.index}
                    data-parentcompindex={this.props.index}
                    data-index={index}
                    onClick={this.changeCount}>{item.count_num}</label>
                }
                <label
                  className="bbs-content-btn ico-moon icon-reply comment-reply-btn"
                  data-compindex={this.props.index}
                  data-index={index}
                  onClick={this.clickBbsReplyBtn}></label>
              </div>
            </div>
          </div>
        })}
        {/* 加载loading */}
        {
          data.loading && 
          <RequestStatus is="requestLoading"></RequestStatus>
        }
        {/* 加载没有数据 */}
        {
          content.is_more == 0 && content.data.length == 0 &&
          <RequestStatus is="requestNone" data={{ data: '还没有评论呦~'}}></RequestStatus>
        }
        {/* 加载失败 */}
        {
          data.loadingFail &&
          <RequestStatus is="requestFail" data={{refreshEvent: 'bbsScrollFuc', compindex: this.props.index}}></RequestStatus>
        }
        {/* 加载完所有数据 */}
        {
           content.is_more == 0 && content.data.length > 0 &&
          <RequestStatus is="requestAll"></RequestStatus>
        }
      </div>
      {!mode
        ? <div className="bbs-fix-btn" style={{
          bottom: app.isTabBarPage() ? '48px' : ''
        }}>
          <button className="ico-moon icon-bbs-comment"
                  data-compindex={this.props.index}
                  onClick={this.showBbsReplyDialog}>评论</button>
          <span></span>
          {/* TODO */}
          <button className="ico-moon icon-bbs-share">分享</button>
        </div>
        : <div className="bbs-fix-btn" style={{
          bottom: app.isTabBarPage() ? '48px' : ''
        }}>
          <span style={{
            display: 'inline-block',
            width: '5.3rem',
            border: '1px solid #ddd',
            borderRadius: '.08rem',
            verticalAlign: 'middle',
            margin: '.18rem',
            height: 'calc(.6rem - 2px)',
            textIndent: '.1rem',
            height: '.6rem',
            backgroundColor: '#fff',
            lineHeight: '.6rem',
            color: '#666'
          }}
            data-compindex={this.props.index}
            onClick={this.showBbsReplyDialog}>写评论...</span>
          <button className="ico-moon icon-bbs-share"
            style={{
              backgroundColor: themeColor,
              color: '#fff',
              width: '1.38rem',
              fontSize: '.28rem',
              padding: '0 .1rem',
              borderRadius: '.08rem',
              margin: '.18rem',
              height: '.6rem',
              lineHeight: '.6rem',
              float: 'right'
            }}>分享</button>
        </div>
      }
      <div className="replyDialog"
        style={{ display: !isShowReplyDialog ? 'none' : 'block' }}
        data-compindex={this.props.index}
        onClick={this.hideBbsReplyDialog}>
        <div onClick={this.stopPropagation} style={dialogTop ? { top: dialogTop + 'px' } : {}}>
          <div className="bbs-dialog-title">发评论
            <span
              style={{ float: 'right', fontSize: '.36rem' }}
              className='ico-moon icon-downarrow'
              data-compindex={this.props.index}
              onClick={this.hideBbsReplyDialog}>
            </span>/
          </div>
          <div style={{ backgroundColor: '#efefef', margin: '.1rem 0' }}>
            {/* TODO */}
            <textarea ref={(input) => this.input = input}
                      value={comment.text || ''}
                      data-compindex={this.props.index}
                      onInput={this.bbsInputComment}
                      onChange={() => {}}></textarea>
            {comment.img && comment.img.map((item, index) => {
              return <div key={index} style={{ position: 'relative', width: '1.4rem', display: 'inline-block', marginRight: '.2rem' }}>
                <span className="delete-comment-img"
                      data-index={index}
                      data-compindex={this.props.index}
                      onClick={this.deleteCommentImage}></span>
                <img className="bbs-comment-img" src={item} />
              </div>
            })}
          </div>
          <div>
            <span className="ico-moon icon-pic selectBbsPic">
              <ImgUpload complete={(url) => this.uploadBbsCommentImage(url)}></ImgUpload>
            </span>
            <span className="bbs-publish-btn"
                  style={{ backgroundColor: (comment.text && comment.text.length || comment.img) ? '#3091f2' : '#ccc' }}
                  data-compindex={this.props.index}
                  onClick={(replyIndex == undefined || replyIndex == 'undefined') ? this.bbsPublishComment : this.bbsPublishReply}>发送</span>
          </div>
        </div>
      </div>
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/bbs-custom-component/BbsCustomComponent.jsx